(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
import React from 'react';
import { Link } from 'react-router-dom';
import ImageWebp from '../components/custom/ImageWebp';
import imgOpeningDoorsInitiativeOffersAffordableHousingOneMicroUnitAtATime from '../public/images/blog/opening-doors-initiative-offers-affordable-housing-one-micro-unit-at-a-time.jpg';
import imgArticleMobileStudentLivingMadeSimpleDiscovertheBenefitsofCBMApartments from '../public/images/blog/small/student-living-made-simple-discover-the-benefits-of-cbm-apartments.jpg'; // Asegúrate de agregar la imagen
import imgArticleMobileMoveInMadeEasyYourUltimateUSCOffCampusApartmentChecklist from '../public/images/blog/small/move-in-made-easy-your-ultimate-usc-off-campus-apartment-checklist.jpg';
import imgArticleMobileUnlockYourDreamStudentHomeExploreCBMsExclusiveApartmentsNearUSC from '../public/images/blog/small/unlock-your-dream-student-home-explore-cbms-exclusive-apartments-near-usc.jpg';
import imgScaryGoodTimesCommunityBuildersManagementSRoommateGuideToHalloween from '../public/images/blog/small/scary-good-times-community-builders-management-s-roommate-guide-to-halloween.jpg';
import StudentHousing101HowToChooseTheRightPlaceIn5EasySteps from '../public/images/blog/small/student-housing-near-usc-how-cbm-helps-you-choose-the-right-place-in-5-easy-steps.jpg';
export default function LatestArticle() {
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-news__lately"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "h4 text-center grid-news__lately__borderButtomBlack"
  }, "Lately on the Blog"), /*#__PURE__*/React.createElement(Link, {
    to: "/blog-news/student-housing-near-usc-how-cbm-helps-you-choose-the-right-place-in-5-easy-steps",
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "grid-news__lately__item"
  }, /*#__PURE__*/React.createElement(ImageWebp, {
    src: StudentHousing101HowToChooseTheRightPlaceIn5EasySteps,
    alt: "Student Housing Near USC: How CBM Helps You Choose the Right Place in 5 Easy Steps",
    className: "img-fluid",
    width: "125",
    height: "84"
  }), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("span", null, "Jan 22, 2026"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Student Housing Near USC: How CBM Helps You Choose the Right Place in 5 Easy Steps")))), /*#__PURE__*/React.createElement(Link, {
    to: "/blog-news/opening-doors-initiative-offers-affordable-housing-one-micro-unit-at-a-time",
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "grid-news__lately__item"
  }, /*#__PURE__*/React.createElement(ImageWebp, {
    src: imgOpeningDoorsInitiativeOffersAffordableHousingOneMicroUnitAtATime,
    alt: "The Keys to Hope: Opening Doors initiative offers affordable housing, one micro unit at a time",
    className: "img-fluid",
    width: "125",
    height: "84"
  }), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("span", null, "Nov 27, 2025"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "The Keys to Hope: Opening Doors initiative offers affordable housing, one micro unit at a time")))), /*#__PURE__*/React.createElement(Link, {
    to: "/blog-news/scary-good-times-community-builders-management-s-roommate-guide-to-halloween",
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "grid-news__lately__item"
  }, /*#__PURE__*/React.createElement(ImageWebp, {
    src: imgScaryGoodTimesCommunityBuildersManagementSRoommateGuideToHalloween,
    alt: "Scary Good Times: Community Builders Management's Roommate Guide to Halloween",
    className: "img-fluid",
    width: "125",
    height: "84"
  }), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("span", null, "OCTOBER 30, 2025"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Scary Good Times: Community Builders Management's Roommate Guide to Halloween")))), /*#__PURE__*/React.createElement(Link, {
    to: "/blog-news/unlock-your-dream-student-home-explore-cbms-exclusive-apartments-near-usc",
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "grid-news__lately__item"
  }, /*#__PURE__*/React.createElement(ImageWebp, {
    src: imgArticleMobileUnlockYourDreamStudentHomeExploreCBMsExclusiveApartmentsNearUSC,
    alt: "Unlock Your Dream Student Home: Explore CBM\u2019s Exclusive Apartments near USC",
    className: "img-fluid",
    width: "125",
    height: "84"
  }), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("span", null, "JUNE 05, 2025"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Unlock Your Dream Student Home: Explore CBM\u2019s Exclusive Apartments near USC")))), /*#__PURE__*/React.createElement(Link, {
    to: "/blog-news/move-in-made-easy-your-ultimate-usc-off-campus-apartment-checklist",
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "grid-news__lately__item"
  }, /*#__PURE__*/React.createElement(ImageWebp, {
    src: imgArticleMobileMoveInMadeEasyYourUltimateUSCOffCampusApartmentChecklist,
    alt: "Move-In Made Easy: Your Ultimate USC Off-Campus Apartment Checklist",
    className: "img-fluid",
    width: "125",
    height: "84"
  }), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("span", null, "JUNE 04, 2025"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Move-In Made Easy: Your Ultimate USC Off-Campus Apartment Checklist")))), /*#__PURE__*/React.createElement(Link, {
    to: "/blog-news/student-living-made-simple-discover-the-benefits-of-cbm-apartments",
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "grid-news__lately__item"
  }, /*#__PURE__*/React.createElement(ImageWebp, {
    src: imgArticleMobileStudentLivingMadeSimpleDiscovertheBenefitsofCBMApartments,
    alt: "Student Living Made Simple: Discover the Benefits of CBM Apartments",
    className: "img-fluid",
    width: "125",
    height: "84"
  }), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("span", null, "NOVEMBER 01, 2024"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Student Living Made Simple: Discover the Benefits of CBM Apartments")))));
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(LatestArticle, "LatestArticle", "/var/www/html/websites/livecbm-com/src/frontend/components/LatestArticle.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();